import React, { Component } from "react";
import { Table, Button, Input, Spinner } from "reactstrap";
import axios from "axios";
import {
  API_URL_lideres_profit,
  API_URL_lideres_profit_update,
} from "../../constants";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getAuthHeaders } from "../../utils/auth";

class LidersList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // key: row index -> value: string/number being edited
      profitShares: {},
      // which row is saving
      savingRow: null,
    };
  }

  static defaultProps = {
    lideres: [],
  };

  componentDidMount() {
    // Prefill inputs with current utilidad so the user can adjust directly
    const profitShares = {};
    (this.props.lideres || []).forEach((l, idx) => {
      if (typeof l?.utilidad === "number") {
        profitShares[idx] = String(l.utilidad);
      }
    });
    this.setState({ profitShares });
  }

  componentDidUpdate(prevProps) {
    // If the leaders list changes (e.g. after refresh), re-seed inputs
    if (prevProps.lideres !== this.props.lideres) {
      const profitShares = {};
      (this.props.lideres || []).forEach((l, idx) => {
        profitShares[idx] = (l?.utilidad ?? "") + "";
      });
      this.setState({ profitShares });
    }
  }

  handleProfitShareChange = (index, event) => {
    const value = event.target.value;
    this.setState((prev) => ({
      profitShares: { ...prev.profitShares, [index]: value },
    }));
  };

  handleKeyDown = (index, e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      this.saveProfitShare(index);
    }
  };

  saveProfitShare = async (index) => {
    const headers = getAuthHeaders();
    if (!headers || Object.keys(headers).length === 0) {
      toast.error("No tienes sesión. Inicia sesión para guardar cambios.");
      return;
    }

    const row = this.props.lideres[index];
    if (!row) {
      toast.error("Fila inválida.");
      return;
    }

    const leader = row.lider;
    const pk = row.pk;
    const raw = this.state.profitShares[index];

    // Parse and validate %
    const profitShare = parseFloat(raw);
    if (Number.isNaN(profitShare)) {
      toast.error("Ingresa un porcentaje numérico.");
      return;
    }
    if (profitShare < 0 || profitShare > 100) {
      toast.error("El porcentaje debe estar entre 0 y 100.");
      return;
    }

    const url = pk ? `${API_URL_lideres_profit_update}/${pk}/` : API_URL_lideres_profit;
    const method = pk ? "put" : "post";
    const data = pk ? { utilidad: profitShare } : { lider: leader, utilidad: profitShare };

    // Debug logs
    // eslint-disable-next-line no-console
    console.log("[LidersList] Saving:", { method, url, data, headers });

    this.setState({ savingRow: index });
    try {
      await axios({ method, url, data, headers });
      toast.success(`Utilidad compartida para ${leader} se actualizó a ${profitShare}%`);
      // If parent passed a refresh
      if (this.props.resetState) this.props.resetState();
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error("[LidersList] Save error:", error);
      if (error?.response?.status === 401) {
        toast.error("No autorizado (401). Revisa tu sesión/token.");
      } else if (error?.response?.status === 403) {
        toast.error("Prohibido (403). No tienes permiso para esta acción.");
      } else {
        toast.error(`Error con ${leader}: ${error?.message || "Error desconocido"}`);
      }
    } finally {
      this.setState({ savingRow: null });
    }
  };

  render() {
    const { lideres } = this.props;
    const { profitShares, savingRow } = this.state;

    return (
      <div>
        <Table striped responsive>
          <thead>
            <tr>
              <th>Leader</th>
              <th>% de Utilidad Actual</th>
              <th>Nuevo % de Utilidad</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {!lideres || lideres.length === 0 ? (
              <tr>
                <td colSpan="4">No leaders found.</td>
              </tr>
            ) : (
              lideres.map((lider, index) => {
                const current = lider?.utilidad ?? 0;
                const draft = profitShares[index] ?? "";
                const isSaving = savingRow === index;
                const isDirty =
                  draft !== "" && Number.parseFloat(draft) !== Number.parseFloat(current);

                return (
                  <tr key={lider.pk ?? index}>
                    <td>{lider.lider}</td>
                    <td>{current}%</td>
                    <td>
                      <Input
                        type="number"
                        step="0.01"
                        min="0"
                        max="100"
                        placeholder="% de Utilidad"
                        value={draft}
                        onChange={(e) => this.handleProfitShareChange(index, e)}
                        onKeyDown={(e) => this.handleKeyDown(index, e)}
                        className="me-2"
                      />
                    </td>
                    <td>
                      <Button
                        color="primary"
                        onClick={() => this.saveProfitShare(index)}
                        disabled={isSaving || !isDirty}
                      >
                        {isSaving ? (
                          <>
                            <Spinner size="sm" className="me-2" /> Guardando...
                          </>
                        ) : (
                          "Guardar"
                        )}
                      </Button>
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </Table>
        <ToastContainer />
      </div>
    );
  }
}

export default LidersList;